import "~/misc/common";
import DeviceBase from "./device_base";
import { ChartTemperature } from "./chart_temperature";
import { GaugeTemperature } from "./gauge_temperature";
import { TimepickerOptions, TimepickerUI } from "timepicker-ui";
import "timepicker-ui/main.css";

export default class extends DeviceBase {
	connect() {
		const controller = this;

		this.connectBase({
			channel: "ThermostatUiChannel",
			onConnection: (connected) => {
				if (connected) controller.sendCmd('?');
			},
			onEvent: (msg: string) => {
				if (msg.startsWith('temp.')) {
					temperature(msg.replace('temp.', ''));
				}
				if (msg.startsWith('selected_thermometer_id=')) {
					$('#state_selected_thermometer_id').val(msg.replace('selected_thermometer_id=', '')).trigger('change.select2');
				}
				if (msg.startsWith('max_program=')) {
					max_program(msg.replace('max_program=', ''));
				}
				if (msg.startsWith('program=')) {
					program(msg.replace('program=', ''));
				}
				if (msg.startsWith('btn.')) {
					btn(msg.replace('btn.', ''));
				}
				if (msg.startsWith('shutter.position=')) {
					position(msg.replace('shutter.position=', ''));
				}
				if (msg.startsWith('shutter.time.0=')) {
					time0.setValue(getClock(parseInt(msg.replace('shutter.time.0=', ''))));
				}
				if (msg.startsWith('shutter.target.0=')) {
					$('#state_target0').val(parseInt(msg.replace('shutter.target.0=', '')));
				}
				if (msg.startsWith('shutter.time.1=')) {
					time1.setValue(getClock(parseInt(msg.replace('shutter.time.1=', ''))));
				}
				if (msg.startsWith('shutter.target.1=')) {
					$('#state_target1').val(parseInt(msg.replace('shutter.target.1=', '')));
				}
			}
		});

		const config: Partial<TimepickerOptions> = {
			clock: {
				type: '24h',
				incrementMinutes: 5,
				autoSwitchToMinutes: true
			},
			labels: {
				time: 'Válassz időpontot',
				cancel: 'Mégse'
			},
			behavior: {
				delayHandler: 20
			}
		};
		const time0 = new TimepickerUI("#state_time0", config);
		time0.create();
		const time1 = new TimepickerUI("#state_time1", config);
		time1.create();

		function getClock(sec: number) {
			return ('0' + Math.floor(sec / 3600)).slice(-2) + ':' + ('0' + (Math.floor(sec / 60) % 60)).slice(-2);
		}

		const el = this.element as HTMLDivElement;
		const thermometers = JSON.parse(el.dataset.thermometers!);
		console.log(thermometers);
		const gap_percent = JSON.parse(el.dataset.gap!);

		function temperature(msg: string) {
			const parts = msg.split("=");
			const temp = parseFloat(parts[1]) / 10.0;
			const mac = parts[0];
			gauges.updateGauge(mac, temp);
		}

		let maxProgram = 0;
		function max_program(msg: string) {
			maxProgram = parseInt(msg);
			$('#program').empty();
			for (let i = 0; i < maxProgram; i++) {
				$('#program').append('<button class="btn btn-default btn-program" id="program' + i + '">P' + (i + 1) + '</button>');
			}
			$('.btn-program').click(function () {
				$('.btn-program').removeClass('active');
				$(this).addClass('active');
				$(this).blur();
				controller.sendCmd('program=' + $(this)[0].id.substring(7));
			});
			controller.sendCmd('program?');
		}

		function program(msg: string) {
			$('.btn-program').removeClass('active');
			$('#program' + msg).addClass('active');
		}

		function btn(msg: string) {
			const parts = msg.split("=");
			if (parts[1] == '0') {
				$('#btn' + parts[0]).removeClass('active');
			} else {
				$('#btn' + parts[0]).addClass('active');
			}
		}

		function position(msg: string) {
			$('#shutter img').css('top', '-' + msg + '%');
		}


		$('#shutterUp').on('click', function () {
			$(this).blur();
			controller.sendCmd('shutter.target=100');
		});

		$('#shutterDown').on('click', function () {
			$(this).blur();
			controller.sendCmd('shutter.target=0');
		});

		$('#shutterGap').on('click', function () {
			$(this).blur();
			controller.sendCmd('shutter.target=' + gap_percent);
		});

		$('#shutter').on('click', function (e) {
			const bounds = e.currentTarget.getBoundingClientRect();
			let percent = (e.clientY - bounds.top) / 300.0 * 100.0;
			percent = Math.max(0.0, percent);
			percent = Math.min(100.0, percent);
			percent = 100 - percent;
			controller.sendCmd('shutter.target=' + Math.round(percent));
		});

		time0.on('confirm', (data) => {
			if (data.hour && data.minutes) {
				const sec = Number(data.hour) * 60 * 60 + Number(data.minutes) * 60;
				controller.sendCmd('shutter.time.0=' + sec);
			}
		});

		$('#state_target0').on('change', function () {
			let percent = $('#state_target0').myGetNumValue() ?? 0;
			percent = Math.max(0.0, percent);
			percent = Math.min(100.0, percent);
			controller.sendCmd('shutter.target.0=' + Math.round(percent));
		});

		time1.on('confirm', (data) => {
			if (data.hour && data.minutes) {
				const sec = Number(data.hour) * 60 * 60 + Number(data.minutes) * 60;
				controller.sendCmd('shutter.time.1=' + sec);
			}
		});

		$('#state_target1').on('change', function () {
			let percent = $('#state_target1').myGetNumValue() ?? 0;
			percent = Math.max(0.0, percent);
			percent = Math.min(100.0, percent);
			controller.sendCmd('shutter.target.1=' + Math.round(percent));
		});

		$('#state_selected_thermometer_id').on('change', function () {
			controller.sendCmd('selected_thermometer_id=' + $('#state_selected_thermometer_id').val());
		});

		// TEMPERATURE GAUGE
		const gauges = new GaugeTemperature(thermometers);

		//LINE CHART
		const chart = new ChartTemperature('#line', controller.mac_address);
	}
}

